import * as Yup from 'yup'
import { imageNullInputSchema } from './common'
const commonValidationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Descrption is required'),
  symptoms: Yup.array()
    .of(Yup.object().required('Symptoms is required'))
    .min(1, 'At least one  symptoms is required')
    .required('Symptoms are required'),
  images: Yup.array().of(imageNullInputSchema),
  infos: Yup.object({
    expectedResultTime: Yup.string().required(
      'Expected Result Time is required',
    ),
    suggestedGender: Yup.string().required('Suggested gender is required'),
    availability: Yup.string().required('Availability is required'),
    suggestedAgeGroups: Yup.array()
      .of(Yup.string().required('Suggested Age Group is required'))
      .required('Suggested Group is required'),
    additionalNote: Yup.string().notRequired(),
    price: Yup.number().required('Price is required'),
    works: Yup.array()
      .of(Yup.string().required('Work is required'))
      .required('Works is required'),
    discount: Yup.number().notRequired(),
  }),
})
const singleValidationSchema = Yup.object({
  categories: Yup.array()
    .of(
      Yup.object({
        id: Yup.number().required('Lab Test is required'),
      }).required('Lab Test is required'),
    )
    .min(1, 'Lab Test is required')
    .required('Lab Tests are required'),
}).concat(commonValidationSchema)
const packageValidationSchema = Yup.object({}).concat(commonValidationSchema)
export default {
  singleValidationSchema,
  packageValidationSchema,
}
